export default __webpack_public_path__ + "static/media/REFIN_IMMAGINI-PRESTIGIO-DECORI_STATUARIO_mesh_265.ca363073.jpg";